import React from 'react'
import { toast } from 'react-toastify'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Paging from "../../Paging";
import AdmissionApi from '../../../Services/AdmissionApi';

class UniversityMaster extends React.Component {
  admissionsService = new AdmissionApi();
  state = {
    universities: [],
    selectedUniversity: '',
    page: 1,
    pageSize: 10,
    totalPages: 1
  }

  componentDidMount() {
    this.getData()
  }

  updateState = (newResponse) => {
    this.setState({
      universities: newResponse.data._embedded.Universities,
      page: newResponse.data.page,
      totalPages: newResponse.data.pageCount
    });
  }

  deleteItem = (item) => {
    confirmAlert({
      title: 'Confirm ?',
      message: 'Are You Sure you want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.admissionsService.deleteAd(
              (res) => {
                if(res.status === 200) {
                  toast.success(("University deleted successfully."))
                  this.getData()
                }
              },
              `v1/university/delete`,
              item.id
            )
          }
        },
        {
          label: 'No',
          onClick: () => {
            console.log("Cancel");
          }
        }
      ]
    })
  }

  getData = (page = 1) => {
    const {
      selectedUniversity,
      pageSize
    } = this.state

    let formData = new FormData()
    formData.append('sortParam', 'createdAt')
    formData.append('sortBy', 'desc')
    formData.append('perPage', pageSize)

    this.admissionsService.getAds(
      this.updateState,
      `v1/university/list?page=${page}`,
      formData
    )
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = () => this.getData()

  clearFilter = () => {
    this.setState({
      selectedUniversity: ''
    }, this.getData)
  }

  handlePageChange = (page) => this.getData(page)

  render() {
    const {
      page,
      totalPages,
      selectedUniversity,
      universities
    } = this.state

    const { showDetails, updateRoutePage } = this.props

    return (
      <section className="dash-alerts">
        <div className="alert-filter">
          {/* <input
            id="selectedUniversity"
            value={selectedUniversity}
            type="text"
            className="form-control alert-filter__input mr-2"
            placeholder="Search for university"
            onChange={this.handleFilterInputChange}
          />
          <button onClick={this.filterList} className="btn btn--primary">
            Submit
          </button>
          <button onClick={this.clearFilter} className="btn btn--default ml-2">
            Clear
          </button> */}
          <button onClick={() => updateRoutePage('university-form')} className='btn btn--new ml-auto'>
            <i className="icon-plus" />
          </button>
        </div>
        <table className="table table-responsive career-table alert-table">
          <thead>
            <tr>
              <th scope="col">University</th>
              <th scope="col">Contact Person</th>
              <th scope="col">Phone Number</th>
              <th scope="col">Live Ads</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {universities.map(item => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.contactPerson}</td>
                <td>{item.mobile}</td>
                <td>{item.totalLiveAdvertisement}/{item.totalAdvertisement}</td>
                <td className='d-flex'>
                  <button className="btn btn-link alert-table__link" onClick={() => showDetails('university-form', item)}>
                    <i className="icon-pencil" />
                  </button>
                  <button className="btn btn-link alert-table__link" onClick={() => this.deleteItem(item)}>
                    <i className="icon-trash" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
      </section>
    )
  }
}

export default UniversityMaster



/** WEBPACK FOOTER **
 ** ./src/components/Admin/UniversityMaster/index.js
 **/